export default __webpack_public_path__ + "088f16033c0c209777f0e27123840166.png";